import {graphql, compose} from 'react-apollo'
import Theme from './components/index'
import {getBlogs,shareActivity} from './actions/queries'
import {updateThemeVote, insertThemeComment, clickQuestionButton,playVideoCount} from './actions/mutation'
import get from 'lodash/get'

export default compose(graphql(getBlogs, {
  name: 'theme',
  options: props => ({
    variables: {
      themeId: get(props, 'match.params.themeId'),
      systemType: get(props, 'match.params.systemType'),
      patientId: get(props, 'match.params.patientId'),
    },
    fetchPolicy: 'network-only'
  })
}),
graphql(updateThemeVote, {name: 'updateThemeVote'}),
graphql(clickQuestionButton, {name: 'clickQuestionButton'}),
graphql(shareActivity, {
  name: 'shareActivity',
  options: props => ({
    variables: {
      activityId: get(props, 'match.params.themeId'),
      systemType: get(props, 'match.params.systemType'),
      patientId: get(props, 'match.params.patientId'),
    },
    fetchPolicy: 'network-only'
  })
}),
graphql(playVideoCount, {name: 'playVideoCount'}),
graphql(insertThemeComment, {name: 'insertThemeComment'}),
 )
(Theme)



// WEBPACK FOOTER //
// ./src/modules/theme/index.js